import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discover-two',
  templateUrl: './discover-two.component.html',
  styleUrls: ['./discover-two.component.css']
})
export class DiscoverTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
